export const MAILING_CAMPAIGN_STATUS_OPTIONS = [
  { label: 'Taslak', value: 'DRAFT' },
  { label: 'Gönderiliyor', value: 'SENDING' },
  { label: 'Duraklatıldı', value: 'PAUSED' },
  { label: 'Tamamlandı', value: 'COMPLETED' },
  { label: 'İptal Edildi', value: 'CANCELLED' },
] as const;

const CAMPAIGN_STATUS_LABEL_MAP: Record<string, string> = {
  DRAFT: 'Taslak',
  SENDING: 'Gönderiliyor',
  PAUSED: 'Duraklatıldı',
  COMPLETED: 'Tamamlandı',
  CANCELLED: 'İptal Edildi',
};

const MAILING_LOG_STATUS_LABEL_MAP: Record<string, string> = {
  SENT: 'Gönderildi',
  FAILED: 'Başarısız',
  SKIPPED: 'Atlandı',
  PENDING: 'Bekliyor',
};

const CONTACT_SOURCE_LABEL_MAP: Record<string, string> = {
  MANUAL: 'Manuel',
  IMPORT: 'İçe Aktarım',
};

export const getCampaignStatusLabel = (status?: string | null) => {
  if (!status) return '-';
  return CAMPAIGN_STATUS_LABEL_MAP[status] || status;
};

export const getMailingLogStatusLabel = (status?: string | null) => {
  if (!status) return '-';
  return MAILING_LOG_STATUS_LABEL_MAP[status] || status;
};

export const getMailingSourceLabel = (source?: string | null) => {
  if (!source) return CONTACT_SOURCE_LABEL_MAP.MANUAL;
  return CONTACT_SOURCE_LABEL_MAP[source] || source;
};
